module.exports = __webpack_public_path__ + "static/media/uob.32f5d676.jpg";